import { ExpensePaymentMethod } from "../@types/expense";

// How an expense or supply order was paid. Optional bookkeeping detail asked
// for by Patton's (ticket #13); nothing downstream depends on it. Check
// numbers and the like go in notes.
export const EXPENSE_PAYMENT_METHOD_OPTIONS: {
  value: ExpensePaymentMethod;
  label: string;
}[] = [
  { value: "cash", label: "Cash" },
  { value: "debit_card", label: "Debit card" },
  { value: "credit_card", label: "Credit card" },
  { value: "check", label: "Check" },
  { value: "auto_withdrawal", label: "Automatic withdrawal" },
];

export const formatPaymentMethod = (method?: string | null): string | null =>
  method
    ? EXPENSE_PAYMENT_METHOD_OPTIONS.find((o) => o.value === method)?.label ??
      method
    : null;
